import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';

import { Property } from 'app/modules/projects/projects.types';
import { ResearchService } from 'app/modules/research/research.service';
import { ProjectInsightsService } from 'app/modules/projects/details/insights/insights.service';

@Component({
  selector: 'project-insights-records',
  templateUrl: './records.component.html',
  styleUrls: ['./records.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectInsightsRecordsComponent implements OnInit {
  public property: Property;
  public parcel: any = {};

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly _researchService: ResearchService,
    private readonly _projectInsightsService: ProjectInsightsService,
    private readonly _router: Router,
  ) {}

  ngOnInit() {
    this._projectInsightsService.property$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((property: Property) => {
      if (!property) {
        //SC-47058 - Navigate to parent 'insights' route by going up two levels (removing /:id/records)
        const currentUrl = this._router.url;
        const insightsUrl = currentUrl.split('/').slice(0, -2).join('/');
        this._router.navigateByUrl(insightsUrl);
        return;
      }

      this.property = property;
      this.loadData(this.property);
      this._changeDetectorRef.markForCheck();
    });
  }

  private loadData(property: Property): void {
    this._researchService
      .getParcelByApn(property.apn, property.address.latitude, property.address.longitude)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((taxData) => {
        if (taxData) {
          this.parcel = taxData;
          this._changeDetectorRef.markForCheck();
        }
      });
  }
}
